import Grid from '@mui/material/Grid';
import BigDialog from 'components/BigDialog';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions as flowActions } from 'ducks/flows';
import { actions as stepActions } from 'ducks/steps';
import cloneDeep from 'lodash/cloneDeep';
import SubStepsDetailPanel from 'pages/Flows/Flows/SubStepsDetailPanel';
import SubStepsTable from 'pages/Flows/Flows/SubStepsTable';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreById, groupBy } from 'selectors/generic';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/steps';
import validator from 'utils/tables/validators/steps';
import { currentUser } from 'selectors/currentUser';

// `flow.steps` is a list of ids now, and `step.substeps` is gone; both come out
// of the steps slice, indexed by the column that used to be the nesting.
const stepsByFlow = groupBy('steps', 'flow_id');
const substepsByMasterStep = groupBy('steps', 'master_step_id');

const Component = props => {
  const { flowId, flows, stepsByFlow, substepsByMasterStep, user } = props;
  const {
    alertError, closeParentContainerConfirm, createStep, fetchFlow,
    removeStep, updateStep
  } = props;
  const tableRef = React.useRef(null);

  const [masterStepId, setmasterStepId] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => setmasterStepId(undefined);

  const allSteps = stepsByFlow[flowId] || [];
  const masterdSteps = cloneDeep(allSteps.filter(s => s.master_step_id === null));

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={closeParentContainerConfirm}
        title={`ETAPAS - ${flows[flowId].code} - ${flows[flowId].name}`}
        columns={columns(user)}
        data={masterdSteps}
        onRowClick={() => null}
        onRowDoubleClick={rowData => setmasterStepId(rowData.id)}
        options={{
          actionsCellStyle: {
            width: 200,
            paddingLeft: 20
          }
        }}
        isLoading={loading}
        actions={[
          {
            icon: tableIcons.Add,
            tooltip: 'Adicionar Sub-Etapas',
            onClick: (event, rowData) => setmasterStepId(rowData.id)
          }
        ]}
        detailPanel={[
          rowData => {
            const subSteps = substepsByMasterStep[rowData.id] || [];
            return subSteps.length === 0 ?
              {
                disabled: true,
                icon: tableIcons.NoIcon,
                render: () => {
                }
              } :
              {
                icon: tableIcons.SubSteps,
                tooltip: 'Lista Sub Etapas',
                render: () => <SubStepsDetailPanel data={subSteps}/>
              };
          }
        ]}
        editable={{
          onRowAdd: newData => {
            setLoading(true);
            const validation = validator(newData, allSteps);
            if (validation.error) {
              alertError(validation.error);
              setLoading(false);
              return Promise.reject();
            } else {
              return createStep({ ...validation, flow_id: flowId, master_step_id: null })
                .then(() => fetchFlow(flowId))
                .then(() => setLoading(false))
                .catch(e => {
                  setLoading(false);
                  alert(e);
                });
            }
          },
          onRowUpdate: (newData, oldData) => {
            setLoading(true);
            const validation = validator(newData, allSteps);
            if (validation.error) {
              alertError(validation.error);
              setLoading(false);
              return Promise.resolve();
              // TODO Instead of rejecting we are resolving, should be rejecting.
              // Have to update library later github issue #2086
            } else {
              return updateStep(newData.id, newData)
                .then(() => fetchFlow(flowId))
                .then(() => setLoading(false))
                .catch(e => {
                  setLoading(false);
                  alert(e);
                });
            }
          },
          onRowDelete: oldData => {
            setLoading(true);
            return removeStep(oldData.id).then(() => fetchFlow(flowId))
              .then(() => setLoading(false))
              .catch(e => {
                setLoading(false);
                alert(e);
              });
          }
        }}
      />
      <BigDialog open={!!masterStepId} handleClose={handleCloseDialog}>
        {
          masterStepId &&
          <SubStepsTable
            masterStepId={masterStepId}
          />
        }
      </BigDialog>
    </Grid>
  );
};

const makeMapStateToProps = () => {
  const flows = getImmutableStoreById('flows');
  const mapStateToProps = (state, props) => ({
    flows: flows(state),
    stepsByFlow: stepsByFlow(state),
    substepsByMasterStep: substepsByMasterStep(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  createStep: data => dispatch(stepActions.createPromise(data)),
  removeStep: id => dispatch(stepActions.removePromise(id)),
  updateStep: (id, data) => dispatch(stepActions.updatePromise(id, data)),
  fetchFlow: id => dispatch(flowActions.fetchOne(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
